module.exports = __webpack_public_path__ + "img/MDI-pdf.5c1513d3.svg";